import { eventBus } from 'utils/eventBus';
import { loadInContextEditor } from 'utils/loadInContextEditor';
import i18n from 'i18n';
import { call, put, select } from 'redux-saga/effects';
import { SignalingSocket } from 'services/signaling';
import { rolesLocalized, selectRoleEntries } from 'features/permissions/permissionsSlice';
import { RoleEntries } from 'features/permissions/types';
import { localizeRoles } from 'features/permissions/utils/localizeRoles';
import { board } from 'utils/whiteboard/BoardStateManager';
import { contentBoard } from 'features/content-whiteboard/utils/contentBoardStateManager';
import { languageChanged } from 'features/application/applicationSlice';
import { languageChangeRequested } from 'features/application/actions';
import { localizeBreakoutRoomNames } from 'features/breakout-rooms/utils/localizeBreakoutRoomNames';
import { BreakoutRoomEntries } from 'features/breakout-rooms/types';
import {
  breakoutRoomsLocalized,
  selectBreakoutRoomsEntries,
} from 'features/breakout-rooms/breakoutRoomsSlice';
import { sharedFolderLocalized } from 'features/content-library/contentLibrarySlice';
import { ContentLibraryManager } from 'utils/content-library/ContentLibraryManager';

export function* changeLanguageSaga(action: ReturnType<typeof languageChangeRequested>) {
  yield call(i18n.changeLanguage, action.payload);
  yield put(languageChanged(action.payload));

  yield call(eventBus.sendMessage, 'appLanguageChanged', {}, { language: action.payload });

  yield call(SignalingSocket.send, {
    event: 'changeDisplayLanguage',
    data: { code: action.payload },
  });

  if (action.payload === 'ach-UG') {
    yield call(loadInContextEditor);
  }

  yield call(board.updateLocale, action.payload);
  yield call(contentBoard.updateLocale, action.payload);

  // localize roles on every language change
  const roles: RoleEntries = yield select(selectRoleEntries);
  const localizedRoles: RoleEntries = yield call(localizeRoles, roles);

  yield put(rolesLocalized(localizedRoles));

  // localize breakout room names on every language change
  const breakoutRooms: BreakoutRoomEntries = yield select(selectBreakoutRoomsEntries);

  if (Object.keys(breakoutRooms).length > 0) {
    const localizedBreakoutRooms: BreakoutRoomEntries = yield call(
      localizeBreakoutRoomNames,
      breakoutRooms
    );
    yield put(breakoutRoomsLocalized(localizedBreakoutRooms));
  }

  // localize shared folder name on every language change
  const localizedSharedFolderName: string = yield call(i18n.t, 'common:shared_content_folder_name');
  yield put(sharedFolderLocalized(localizedSharedFolderName));

  yield call(ContentLibraryManager.setLocale, action.payload);
}
